import { FieldTypes, systemDateField } from 'drapcode-constant';
export const defaultFields1 = [
  'id',
  'createdat',
  'createdby',
  'updatedby',
  'isdeleted',
  'updatedat',
];
export const defaultFields2 = [
  FieldTypes.date.id,
  'createdat',
  'updatedat',
  ...systemDateField,
  FieldTypes.time_slot.id,
];

export const tooltipInfoTitles = {
  plsPermissions: `<ul style="padding-left: 1rem"><li><strong>Allowed</strong> – Field will exist in the JSON object. </li><li><strong>Not Allowed</strong> – Field will be removed from the JSON object. </li><li><strong>Restricted</strong> – Field will exist in the JSON object based on the Allowed Permissions. </li></ul>`,
  plsAllowedPermissions: `<ul style="padding-left: 1rem"><li><strong>When Empty (don't have any permission assigned)</strong> – Field will exist in the JSON object with restricted data. </li><li><strong>When assigned permission(s)</strong> – Field will exist in the JSON object for the given permissions only. </li></ul>`,
  plsReferenceFields: `Depenedent on Permissions' <strong>Restricted</strong> value.</br><ul style="padding-left: 1rem"><li><strong>When Empty</strong> – Field will exist in the JSON object with empty list. </li><li><strong>When selected reference fields</strong> – Field will exist in the JSON object with the selected reference fields only. </li></ul>`,
  plsSortOrder: `Select how the options should be sorted in the dropdown. </br><ul style="padding-left: 1rem"><li><strong>Alphabetical (A to Z)</strong> will sort options in alphabetical ascending order.<li><strong>Reverse Alphabetical (Z to A)</strong> will sort options in alphabetical descending order.</li><li><strong>No Sorting</strong> will keep the order of options as they were added.</li></ul>`,
};

export const filterNotAllowedCollections = [
  'permission',
  'search_history',
  'audit_log',
  'audit_trail',
  'task_stats',
  'docusign_tokens',
  'docusign_activity_tracker',
  'file_activity_tracker',
  'user_activity_tracker',
  'aws_sns_sms_activity_tracker',
  'twilio_sms_activity_tracker',
  'aws_ses_activity_tracker',
  'data_view_activity_tracker',
  'chat_room',
  'message',
  'sendgrid_activity_tracker',
  'socket_io_activity_tracker',
  'text_anonymization_activity',
  'parken_sms_activity_tracker',
  'resend_activity_tracker',
  'mpesa_oauth_tokens',
  'google_calendar_oauth_tokens',
  'google_meet_oauth_tokens',
  'box_oauth_tokens',
  'zoom_oauth_tokens',
  'mpesa_oauth_tokens',
  'spin_mobile_oauth_tokens',
  'africas_talking_sms_activity_tracker',
  'hostpinnacle_sms_activity_tracker',
];

export const tableParams = [
  'tableStyle',
  'theadStyle',
  'tbodyStyle',
  'trStyle',
  'tdStyle',
  'thStyle',
];
export const hideSetting = [
  'derivedFields',
  'collectionConstants',
  'projectConstants',
  'userDerivedFields',
  'authToken',
  'tenantFields',
  'userSettingFields',
  'subTenantFields',
];

export const localStorageKey = {
  ENVIRONMENT: 'environment',
  DEBUG_MODE: 'debugMode',
  UPDATE_COLLECTION: 'updatedCollections',
};

export const COUNTRY_OPTIONS = [
  { value: 'AF', label: '🇦🇫 Afghanistan' },
  { value: 'AL', label: '🇦🇱 Albania' },
  { value: 'DZ', label: '🇩🇿 Algeria' },
  { value: 'AD', label: '🇦🇩 Andorra' },
  { value: 'AO', label: '🇦🇴 Angola' },
  { value: 'AG', label: '🇦🇬 Antigua and Barbuda' },
  { value: 'AR', label: '🇦🇷 Argentina' },
  { value: 'AM', label: '🇦🇲 Armenia' },
  { value: 'AU', label: '🇦🇺 Australia' },
  { value: 'AT', label: '🇦🇹 Austria' },
  { value: 'AZ', label: '🇦🇿 Azerbaijan' },

  { value: 'BS', label: '🇧🇸 Bahamas' },
  { value: 'BH', label: '🇧🇭 Bahrain' },
  { value: 'BD', label: '🇧🇩 Bangladesh' },
  { value: 'BB', label: '🇧🇧 Barbados' },
  { value: 'BY', label: '🇧🇾 Belarus' },
  { value: 'BE', label: '🇧🇪 Belgium' },
  { value: 'BZ', label: '🇧🇿 Belize' },
  { value: 'BJ', label: '🇧🇯 Benin' },
  { value: 'BT', label: '🇧🇹 Bhutan' },
  { value: 'BO', label: '🇧🇴 Bolivia' },
  { value: 'BA', label: '🇧🇦 Bosnia and Herzegovina' },
  { value: 'BW', label: '🇧🇼 Botswana' },
  { value: 'BR', label: '🇧🇷 Brazil' },
  { value: 'BN', label: '🇧🇳 Brunei' },
  { value: 'BG', label: '🇧🇬 Bulgaria' },
  { value: 'BF', label: '🇧🇫 Burkina Faso' },
  { value: 'BI', label: '🇧🇮 Burundi' },

  { value: 'CV', label: '🇨🇻 Cabo Verde' },
  { value: 'KH', label: '🇰🇭 Cambodia' },
  { value: 'CM', label: '🇨🇲 Cameroon' },
  { value: 'CA', label: '🇨🇦 Canada' },
  { value: 'CF', label: '🇨🇫 Central African Republic' },
  { value: 'TD', label: '🇹🇩 Chad' },
  { value: 'CL', label: '🇨🇱 Chile' },
  { value: 'CN', label: '🇨🇳 China' },
  { value: 'CO', label: '🇨🇴 Colombia' },
  { value: 'KM', label: '🇰🇲 Comoros' },
  { value: 'CG', label: '🇨🇬 Congo' },
  { value: 'CD', label: '🇨🇩 Democratic Republic of the Congo' },
  { value: 'CR', label: '🇨🇷 Costa Rica' },
  { value: 'CI', label: "🇨🇮 Côte d'Ivoire" },
  { value: 'HR', label: '🇭🇷 Croatia' },
  { value: 'CU', label: '🇨🇺 Cuba' },
  { value: 'CY', label: '🇨🇾 Cyprus' },
  { value: 'CZ', label: '🇨🇿 Czechia' },

  { value: 'DK', label: '🇩🇰 Denmark' },
  { value: 'DJ', label: '🇩🇯 Djibouti' },
  { value: 'DM', label: '🇩🇲 Dominica' },
  { value: 'DO', label: '🇩🇴 Dominican Republic' },

  { value: 'EC', label: '🇪🇨 Ecuador' },
  { value: 'EG', label: '🇪🇬 Egypt' },
  { value: 'SV', label: '🇸🇻 El Salvador' },
  { value: 'GQ', label: '🇬🇶 Equatorial Guinea' },
  { value: 'ER', label: '🇪🇷 Eritrea' },
  { value: 'EE', label: '🇪🇪 Estonia' },
  { value: 'SZ', label: '🇸🇿 Eswatini' },
  { value: 'ET', label: '🇪🇹 Ethiopia' },

  { value: 'FJ', label: '🇫🇯 Fiji' },
  { value: 'FI', label: '🇫🇮 Finland' },
  { value: 'FR', label: '🇫🇷 France' },

  { value: 'GA', label: '🇬🇦 Gabon' },
  { value: 'GM', label: '🇬🇲 Gambia' },
  { value: 'GE', label: '🇬🇪 Georgia' },
  { value: 'DE', label: '🇩🇪 Germany' },
  { value: 'GH', label: '🇬🇭 Ghana' },
  { value: 'GR', label: '🇬🇷 Greece' },
  { value: 'GD', label: '🇬🇩 Grenada' },
  { value: 'GT', label: '🇬🇹 Guatemala' },
  { value: 'GN', label: '🇬🇳 Guinea' },
  { value: 'GW', label: '🇬🇼 Guinea-Bissau' },
  { value: 'GY', label: '🇬🇾 Guyana' },

  { value: 'HT', label: '🇭🇹 Haiti' },
  { value: 'HN', label: '🇭🇳 Honduras' },
  { value: 'HU', label: '🇭🇺 Hungary' },

  { value: 'IS', label: '🇮🇸 Iceland' },
  { value: 'IN', label: '🇮🇳 India' },
  { value: 'ID', label: '🇮🇩 Indonesia' },
  { value: 'IR', label: '🇮🇷 Iran' },
  { value: 'IQ', label: '🇮🇶 Iraq' },
  { value: 'IE', label: '🇮🇪 Ireland' },
  { value: 'IL', label: '🇮🇱 Israel' },
  { value: 'IT', label: '🇮🇹 Italy' },

  { value: 'JM', label: '🇯🇲 Jamaica' },
  { value: 'JP', label: '🇯🇵 Japan' },
  { value: 'JO', label: '🇯🇴 Jordan' },

  { value: 'KZ', label: '🇰🇿 Kazakhstan' },
  { value: 'KE', label: '🇰🇪 Kenya' },
  { value: 'KI', label: '🇰🇮 Kiribati' },
  { value: 'KP', label: '🇰🇵 North Korea' },
  { value: 'KR', label: '🇰🇷 South Korea' },
  { value: 'KW', label: '🇰🇼 Kuwait' },
  { value: 'KG', label: '🇰🇬 Kyrgyzstan' },

  { value: 'LA', label: '🇱🇦 Laos' },
  { value: 'LV', label: '🇱🇻 Latvia' },
  { value: 'LB', label: '🇱🇧 Lebanon' },
  { value: 'LS', label: '🇱🇸 Lesotho' },
  { value: 'LR', label: '🇱🇷 Liberia' },
  { value: 'LY', label: '🇱🇾 Libya' },
  { value: 'LI', label: '🇱🇮 Liechtenstein' },
  { value: 'LT', label: '🇱🇹 Lithuania' },
  { value: 'LU', label: '🇱🇺 Luxembourg' },

  { value: 'MG', label: '🇲🇬 Madagascar' },
  { value: 'MW', label: '🇲🇼 Malawi' },
  { value: 'MY', label: '🇲🇾 Malaysia' },
  { value: 'MV', label: '🇲🇻 Maldives' },
  { value: 'ML', label: '🇲🇱 Mali' },
  { value: 'MT', label: '🇲🇹 Malta' },
  { value: 'MH', label: '🇲🇭 Marshall Islands' },
  { value: 'MR', label: '🇲🇷 Mauritania' },
  { value: 'MU', label: '🇲🇺 Mauritius' },
  { value: 'MX', label: '🇲🇽 Mexico' },
  { value: 'FM', label: '🇫🇲 Micronesia' },
  { value: 'MD', label: '🇲🇩 Moldova' },
  { value: 'MC', label: '🇲🇨 Monaco' },
  { value: 'MN', label: '🇲🇳 Mongolia' },
  { value: 'ME', label: '🇲🇪 Montenegro' },
  { value: 'MA', label: '🇲🇦 Morocco' },
  { value: 'MZ', label: '🇲🇿 Mozambique' },
  { value: 'MM', label: '🇲🇲 Myanmar' },

  { value: 'NA', label: '🇳🇦 Namibia' },
  { value: 'NR', label: '🇳🇷 Nauru' },
  { value: 'NP', label: '🇳🇵 Nepal' },
  { value: 'NL', label: '🇳🇱 Netherlands' },
  { value: 'NZ', label: '🇳🇿 New Zealand' },
  { value: 'NI', label: '🇳🇮 Nicaragua' },
  { value: 'NE', label: '🇳🇪 Niger' },
  { value: 'NG', label: '🇳🇬 Nigeria' },
  { value: 'MK', label: '🇲🇰 North Macedonia' },
  { value: 'NO', label: '🇳🇴 Norway' },

  { value: 'OM', label: '🇴🇲 Oman' },

  { value: 'PK', label: '🇵🇰 Pakistan' },
  { value: 'PW', label: '🇵🇼 Palau' },
  { value: 'PS', label: '🇵🇸 Palestine' },
  { value: 'PA', label: '🇵🇦 Panama' },
  { value: 'PG', label: '🇵🇬 Papua New Guinea' },
  { value: 'PY', label: '🇵🇾 Paraguay' },
  { value: 'PE', label: '🇵🇪 Peru' },
  { value: 'PH', label: '🇵🇭 Philippines' },
  { value: 'PL', label: '🇵🇱 Poland' },
  { value: 'PT', label: '🇵🇹 Portugal' },

  { value: 'QA', label: '🇶🇦 Qatar' },

  { value: 'RO', label: '🇷🇴 Romania' },
  { value: 'RU', label: '🇷🇺 Russia' },
  { value: 'RW', label: '🇷🇼 Rwanda' },

  { value: 'KN', label: '🇰🇳 Saint Kitts and Nevis' },
  { value: 'LC', label: '🇱🇨 Saint Lucia' },
  { value: 'VC', label: '🇻🇨 Saint Vincent and the Grenadines' },
  { value: 'WS', label: '🇼🇸 Samoa' },
  { value: 'SM', label: '🇸🇲 San Marino' },
  { value: 'ST', label: '🇸🇹 São Tomé and Príncipe' },
  { value: 'SA', label: '🇸🇦 Saudi Arabia' },
  { value: 'SN', label: '🇸🇳 Senegal' },
  { value: 'RS', label: '🇷🇸 Serbia' },
  { value: 'SC', label: '🇸🇨 Seychelles' },
  { value: 'SL', label: '🇸🇱 Sierra Leone' },
  { value: 'SG', label: '🇸🇬 Singapore' },
  { value: 'SK', label: '🇸🇰 Slovakia' },
  { value: 'SI', label: '🇸🇮 Slovenia' },
  { value: 'SB', label: '🇸🇧 Solomon Islands' },
  { value: 'SO', label: '🇸🇴 Somalia' },
  { value: 'ZA', label: '🇿🇦 South Africa' },
  { value: 'SS', label: '🇸🇸 South Sudan' },
  { value: 'ES', label: '🇪🇸 Spain' },
  { value: 'LK', label: '🇱🇰 Sri Lanka' },
  { value: 'SD', label: '🇸🇩 Sudan' },
  { value: 'SR', label: '🇸🇷 Suriname' },
  { value: 'SE', label: '🇸🇪 Sweden' },
  { value: 'CH', label: '🇨🇭 Switzerland' },
  { value: 'SY', label: '🇸🇾 Syria' },

  { value: 'TW', label: '🇹🇼 Taiwan' },
  { value: 'TJ', label: '🇹🇯 Tajikistan' },
  { value: 'TZ', label: '🇹🇿 Tanzania' },
  { value: 'TH', label: '🇹🇭 Thailand' },
  { value: 'TL', label: '🇹🇱 Timor-Leste' },
  { value: 'TG', label: '🇹🇬 Togo' },
  { value: 'TO', label: '🇹🇴 Tonga' },
  { value: 'TT', label: '🇹🇹 Trinidad and Tobago' },
  { value: 'TN', label: '🇹🇳 Tunisia' },
  { value: 'TR', label: '🇹🇷 Türkiye' },
  { value: 'TM', label: '🇹🇲 Turkmenistan' },
  { value: 'TV', label: '🇹🇻 Tuvalu' },

  { value: 'UG', label: '🇺🇬 Uganda' },
  { value: 'UA', label: '🇺🇦 Ukraine' },
  { value: 'AE', label: '🇦🇪 United Arab Emirates' },
  { value: 'GB', label: '🇬🇧 United Kingdom' },
  { value: 'US', label: '🇺🇸 United States' },
  { value: 'UY', label: '🇺🇾 Uruguay' },
  { value: 'UZ', label: '🇺🇿 Uzbekistan' },

  { value: 'VU', label: '🇻🇺 Vanuatu' },
  { value: 'VA', label: '🇻🇦 Vatican City' },
  { value: 'VE', label: '🇻🇪 Venezuela' },
  { value: 'VN', label: '🇻🇳 Vietnam' },

  { value: 'YE', label: '🇾🇪 Yemen' },
  { value: 'ZM', label: '🇿🇲 Zambia' },
  { value: 'ZW', label: '🇿🇼 Zimbabwe' },
];

export const FAILED_TO_PUBLISH = 'Failed to Publish the Application';
export const TRY_AGAIN = 'Failed: Try again after sometime';
export const BUILD_SUCCESSFUL = 'Application Published Successfully!';
export const NETWORK_ERROR = 'network error';
